import React from "react";
import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { FaTrash, FaPlus } from "react-icons/fa";
import { Block } from "../../components";
import { Link, useNavigate } from "react-router-dom";
import FileUpload from "../Constant/fileupload";
import { MdOutlineApps } from "react-icons/md";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { FaQuestionCircle } from "react-icons/fa";
import {
  createfaqApi,
  getfaqDetailsApi,
  getfaqTagsApi,
  updatefaqApi,
} from "../../services/Faq";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
const customStyles = {
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e7f3ff",
    borderRadius: "50px",
    padding: "0.1rem 0.6rem !important",
    border: "1px solid #b6e0fe",
    fontSize: "0.65rem !important",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#055160 !important",
    fontWeight: "500",
    paddingRight: "4px",
    fontSize: "10px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#055160 !important",
    borderRadius: "50%",
    padding: "2px",
    cursor: "pointer",
    ":hover": {
      color: "#dc3545 !important",
    },
  }),
};

const UserOption = [
  { label: "Store Manager", value: "STORE" },
  { label: "Location Manager", value: "LOCATION" },
  { label: "Auditor", value: "AUDITOR" },
  { label: "Employee", value: "EMPLOYEE" },
  { label: "Head of department", value: "HOD" },
  { label: "Admin", value: "ADMIN" },
];

const FaqAdd = () => {
  const navigate =useNavigate()
  const { id } = useParams();
  const isEditMode = Boolean(id);

  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [tagLoading, setTagLoading] = useState(false);

  const [selectedTag, setSelectedTag] = useState([]);
  const [tagOption, setTagOption] = useState([]);

  const [permissionOptions, setPermissionoptions] = useState(UserOption);
  const [selecetdPermissionOptions, setSelecetdPermissionOptions] = useState(
    []
  );

  const [steps, setSteps] = useState(["", ""]);
  const [links, setLinks] = useState([{ name: "", url: "" }]);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");

  const [errors, setErrors] = useState({});

  const getTag = () => {
    setTagLoading(true);
    getfaqTagsApi()
      .then((res) => {
        const option = res?.data?.map((tag) => ({ label: tag, value: tag }));
        setTagOption(option || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setTagLoading(false);
      });
  };

  useEffect(() => {
    getTag();
  }, []);

  useEffect(() => {
    if (isEditMode) {
      getfaqDetailsApi(id)
        .then((res) => {
          const data = res?.data || {};
          setTitle(data?.title || "");
          setSelectedTag(
            data.tags.map((tag) => ({ value: tag, label: tag })) || []
          );
          setSelecetdPermissionOptions(
            data.access_users.map((role) => ({
              value: role,
              label: role,
            })) || []
          );
          setSteps(data.steps || ["", ""]);
          setLinks(
            data.links?.length
              ? data.links.map((l) => ({ name: l.name, url: l.url }))
              : [{ name: "", url: "" }]
          );

          setFile(data.file || null);
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

  const clearError = (field) => {
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleStepChange = (index, value) => {
    const updated = [...steps];
    updated[index] = value;
    setSteps(updated);
    if (value) {
      clearError("steps");
    }
  };

  const addStep = () => {
    setSteps([...steps, ""]);
  };

  const removeStep = (index) => {
    const updated = steps.filter((_, i) => i !== index);
    setSteps(updated);
  };

  const handleLinkChange = (index, field, value) => {
    const updated = [...links];
    updated[index][field] = value;
    setLinks(updated);
  };

  const addLink = () => {
    setLinks([...links, { name: "", url: "" }]);
  };

  const removeLink = (index) => {
    const updated = links.filter((_, i) => i !== index);
    setLinks(updated);
  };

  const handleTagCreate = (inputValue) => {
    const newOption = { value: inputValue.toLowerCase(), label: inputValue };
    setTagOption((prev) => [...prev, newOption]);
    setSelectedTag((prev) => [...(prev || []), newOption]);
  };

  const handleCreatefaq = (data) => {
    setLoading(true);
    createfaqApi(data)
      .then((res) => {
        toast.success("FAQ created successfully");
        handleReset();
        navigate('/faq')
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Something went wrong, please try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleUpdatefaq = (data) => {
    setLoading(true);
    updatefaqApi(id,data)
      .then((res) => {
        handleReset();
        toast.success("FAQ Update successfully");
        navigate('/faq')
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Something went wrong, please try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    let newErrors = {};

    if (!title.trim()) newErrors.title = "FAQ title is required";

    if (!selectedTag || selectedTag.length === 0)
      newErrors.tags = "Please select at least one tag";

    if (!selecetdPermissionOptions || selecetdPermissionOptions.length === 0)
      newErrors.access = "Please select at least one access user";

    const hasValidStep = steps.some((step) => step.trim() !== "");
    if (!hasValidStep) newErrors.steps = "Please add at least one valid step";

    if (!file) newErrors.file = "Please upload an image or GIF";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const payload = {
        title,
        tags: selectedTag.map((t) => t.value),
        accessUsers: selecetdPermissionOptions.map((u) => u.value),
        steps: steps.filter((step) => step.trim() !== ""),
        links, // still full array, will process below
        file,
      };

      const formData = new FormData();

      formData.append("title", payload.title);

      payload.tags.forEach((tag, index) => {
        formData.append(`tags_${index}`, tag);
      });

      payload.accessUsers.forEach((user, index) => {
        formData.append(`accessUsers_${index}`, user);
      });

      payload.steps.forEach((step, index) => {
        formData.append(`steps_${index}`, step);
      });

      payload.links.forEach((link, index) => {
        formData.append(`links_${index}_name`, link.name || "");
        formData.append(`links_${index}_url`, link.url || "");
      });

      if (payload.file instanceof File) {
        formData.append("file", payload.file);
      }

      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}:`, value);
      // }

      if (isEditMode) {
        handleUpdatefaq(formData);
      } else {
        handleCreatefaq(formData);
      }
    }
  };

  const handleReset = () => {
    setTitle("");
    setSelectedTag([]);
    setSelecetdPermissionOptions([]);
    setSteps(["", ""]);
    setLinks([{ name: "", url: "" }]);
    setFile(null);
    setErrors({});
  };

  if (editLoading) {
    return (
      <div className="my-3 text-center">
        <Spinner animation="border" />
      </div>
    );
  }
  return (
    <div>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">FAQ Add</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/faq">FAQ</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Faq Add
                </li>
              </ol>
            </nav>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8">
            <div className="card mb-4">
              <div className="card-body">
                <h5>Basic Information</h5>
                <div className="row g-2">
                  <div className="col-12">
                    <label className="form-label text-dark fw-medium">
                      FAQ Title
                    </label>
                    <input
                      type="text"
                      value={title}
                      className={`form-control ${
                        errors?.title ? "is-invalid" : ""
                      }`}
                      placeholder="Enter FAQ Title..."
                      onChange={(e) => {
                        const value = e.target.value || "";
                        setTitle(value);
                        if (value.trim() !== "") {
                          clearError("title");
                        }
                      }}
                    />
                    {errors?.title && (
                      <small className="text-danger">
                        {errors.title || ""}
                      </small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-dark fw-medium">
                      Tags
                    </label>
                    <CreatableSelect
                      isLoading={tagLoading}
                      isMulti
                      options={tagOption}
                      value={selectedTag}
                      onChange={(value) => {
                        setSelectedTag(value);
                        if (value?.length > 0) {
                          clearError("tags");
                        }
                      }}
                      onCreateOption={handleTagCreate}
                      placeholder="Select or create tags..."
                      classNamePrefix="select"
                      className="react-select"
                      styles={customStyles}
                    />
                    {errors?.tags && (
                      <small className="text-danger">{errors.tags || ""}</small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-dark fw-medium">
                      Acccess User
                    </label>
                    <Select
                      classNamePrefix="select"
                      className="react-select"
                      isMulti
                      options={permissionOptions}
                      onChange={(value) => {
                        setSelecetdPermissionOptions(value);
                        if (value?.length > 0) {
                          clearError("access");
                        }
                      }}
                      value={selecetdPermissionOptions}
                      placeholder="Select user roles..."
                      styles={customStyles}
                    />
                    {errors?.access && (
                      <small className="text-danger">
                        {errors.access || ""}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="card mb-4">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="m-0">Steps</h5>
                  <button
                    className="btn rounded-2 stylish-transparent-btn"
                    onClick={addStep}
                  >
                    <FaPlus className="me-1" /> Add Step
                  </button>
                </div>
                {steps.map((step, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center mb-2 gap-2"
                  >
                    <div className="d-flex align-items-center">
                      <MdOutlineApps />
                      <span className="ms-2">{index + 1}.</span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter step description..."
                      value={step}
                      onChange={(e) => handleStepChange(index, e.target.value)}
                    />
                    {steps.length > 1 && (
                      <button
                        className="btn rounded-2 stylish-transparent-btn text-dark"
                        style={{ padding: "0.3rem 0.4rem" }}
                        onClick={() => removeStep(index)}
                      >
                        <FaTrash size="12" />
                      </button>
                    )}
                  </div>
                ))}
                {errors?.steps && (
                  <small className="text-danger">{errors.steps || ""}</small>
                )}
              </div>
            </div>

            <div className="card mb-4">
              <div className="card-body">
                <h5 className="m-0">Media</h5>
                <div className="mt-3">
                  <FileUpload
                    label="Drag & drop File (max size 3MB)"
                    accept=".jpg,.jpeg,.png,.gif"
                    multiple={false}
                    value={file}
                    onChange={(files) => {
                      setFile(files);
                      if (files) {
                        clearError("file");
                      }
                    }}
                  />
                </div>
                {errors?.file && (
                  <small className="text-danger">{errors.file || ""}</small>
                )}
              </div>
            </div>

            <div className="card mb-4">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="m-0">Optional Links</h5>
                  <button
                    className="btn rounded-2 stylish-transparent-btn"
                    onClick={addLink}
                  >
                    <FaPlus className="me-1" /> Add Link
                  </button>
                </div>
                {links.map((link, index) => (
                  <div className="row mb-2" key={index}>
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Link name"
                        value={link.name}
                        onChange={(e) =>
                          handleLinkChange(index, "name", e.target.value)
                        }
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="https://"
                        value={link.url}
                        onChange={(e) =>
                          handleLinkChange(index, "url", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-auto align-self-center">
                      {links.length > 1 && (
                        <button
                          className="btn rounded-2 stylish-transparent-btn text-dark"
                          style={{ padding: "0.5rem 0.6rem" }}
                          onClick={() => removeLink(index)}
                        >
                          <FaTrash />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card">
              <div className="border-bottom p-2 d-flex gap-1 align-items-center">
                <FaQuestionCircle />
                <h6 className="m-0">Live Preview</h6>
              </div>

              <div className="card-body">
                <h5 className="m-0">
                  {title.trim() || "Your FAQ Title will appear here"}
                </h5>
                <div className="mt-1">
                  <label
                    className="text-dark fw-medium"
                    style={{ fontSize: "0.8rem" }}
                  >
                    Steps:
                  </label>
                  {steps.some((step) => step.trim()) ? (
                    <ol>
                      {steps.map(
                        (step, i) =>
                          step.trim() !== "" && <li key={i}>{step.trim()}</li>
                      )}
                    </ol>
                  ) : (
                    <p className="text-dark small">
                      Your steps will appear here
                    </p>
                  )}
                </div>

                <div
                  className="bg-light text-center p-1 rounded d-flex justify-content-center align-items-center"
                  style={{ minHeight: "80px" }}
                >
                  {typeof file === "string" ? (
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}${file}`}
                      alt="Preview"
                      className="img-fluid rounded"
                      style={{ maxHeight: "150px", objectFit: "contain" }}
                    />
                  ) : file instanceof File ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt="Preview"
                      className="img-fluid rounded"
                      style={{ maxHeight: "150px", objectFit: "contain" }}
                    />
                  ) : (
                    <span className="text-small">Preview Image</span>
                  )}
                </div>

                <div className="mt-1">
                  <label
                    className="text-dark fw-medium"
                    style={{ fontSize: "0.8rem" }}
                  >
                    Tags:
                  </label>
                  <div className="d-flex flex-wrap gap-2">
                    {selectedTag?.length > 0 ? (
                      selectedTag.map((tag) => (
                        <span
                          key={tag.value}
                          className="badge text-bg-info-soft"
                        >
                          {tag.label}
                        </span>
                      ))
                    ) : (
                      <p className="text-dark small">No tag selecetd</p>
                    )}
                  </div>
                </div>

                <div className="mt-1">
                  <label
                    className="text-dark fw-medium"
                    style={{ fontSize: "0.8rem" }}
                  >
                    Links:
                  </label>
                  {links.some((l) => l.name && l.url) ? (
                    <div className="d-flex flex-wrap gap-2">
                      {links.map(
                        (link, i) =>
                          link.name &&
                          link.url && (
                            <a
                              key={i}
                              href={link.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {link.name}
                            </a>
                          )
                      )}
                    </div>
                  ) : (
                    <p className="text-dark small">
                      Optional links will appear here
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3 gap-2">
        <button
          className="btn btn-outline-danger"
          onClick={handleReset}
          disabled={loading}
        >
          Reset
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading && <Spinner animation="border" size="sm" />}
          Save
        </button>
      </div>
    </div>
  );
};

export default FaqAdd;
